import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import "../../assets/ListingModal.css";

function PageList() {
  const [pageList, setPageList] = useState([]);
  const token = sessionStorage.getItem("token");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const filteredData = pageList.filter((item) =>
    Object.values(item).some(
      (val) =>
        val &&
        typeof val === "string" &&
        val.toLowerCase().includes(search.toLowerCase())
    )
  );

  const offset = currentPage * itemsPerPage;
  const paginatedData = filteredData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const fetchPageList = async () => {
    if (!token) {
      toast.error("No token provided!");
      return;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_APIURL}api/page/list`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPageList(response?.data?.data || []);
    } catch (error) {
      toast.error(
        "Error fetching data: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  const handleDeletePage = async () => {
    if (!token || !deleteId) {
      toast.error("No token provided or invalid ID!");
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/page/delete/${deleteId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok) {
        toast.success("Page deleted successfully!");
        fetchPageList();
      } else {
        const data = await response.json();
        toast.error(data.message || "Failed to delete Page");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    }
    setShowModal(false);
  };

  useEffect(() => {
    fetchPageList();
  }, []);

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Page List</h1>
        </div>

        <section className="section">
          <div className="card">
            <div className="card-body">
              <div className="datatable-container overflow-auto">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>SL</th>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.title}</td>
                          <td>{item.description}</td>
                          <td>
                            <div className="d-flex gap-2">
                              <Link to={`/page/edit/${item._id}`}>
                                <i className="bi bi-pencil-square text-primary"></i>
                              </Link>
                              <Link
                                onClick={() => {
                                  setDeleteId(item._id);
                                  setShowModal(true);
                                }}
                              >
                                <i className="bi bi-trash text-danger"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No matching records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <ReactPaginate
                previousLabel={"‹"}
                nextLabel={"›"}
                pageCount={pageCount}
                onPageChange={(e) => setCurrentPage(e.selected)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            </div>
          </div>
        </section>
      </main>

      {/* Delete Confirmation Modal at Top */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        backdrop="static"
        keyboard={false}
        dialogClassName="top-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this page?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeletePage}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PageList;
